import React, { useState, useMemo, useEffect } from 'react';
import styled from 'styled-components';

interface Header1Props {
  title: string;
}

const Header1 = ({ title }: Header1Props) => {
  return (
    <>
      <Header>
        <h1>{title}</h1>
      </Header>
    </>
  );
};

export default Header1;

const Header = styled.header`
  width: 100%;
  height: 66px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 14px;
  background-color: #f2f4f6;

  > h1 {
    font-size: 22px;
    font-weight: 700;
  }
`;
